import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { getStoredConsent } from "@/lib/tracking";

// Fester „Zum Seitenanfang"-Button: bleibt beim Scrollen sichtbar,
// erscheint dezent nach ~600 px und überlappt weder Cookie-Banner noch Kontakt-Leiste.
const BackToTop = () => {
  const [scrolled, setScrolled] = useState(false);
  const [consentDone, setConsentDone] = useState(() => getStoredConsent() !== null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 600);
    const onConsent = () => setConsentDone(true);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("ftd-consent-changed", onConsent);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("ftd-consent-changed", onConsent);
    };
  }, []);

  const visible = scrolled && consentDone;

  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      data-testid="back-to-top-button"
      onClick={toTop}
      aria-label="Zum Seitenanfang"
      tabIndex={visible ? 0 : -1}
      className={`fixed bottom-24 right-4 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-sand bg-creme/90 text-ink shadow-md backdrop-blur transition-all duration-300 hover:bg-moss hover:text-creme lg:bottom-8 lg:right-8 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <ArrowUp size={18} />
    </button>
  );
};

export default BackToTop;
